import React from 'react';
import { Typography } from 'antd';
import './UserItemLabelStyles.css';
const { Text } = Typography;
const UserItemLabel = ({ department }) => (React.createElement("div", { className: 'user-item-label' },
    React.createElement("div", { style: { background: department.color }, className: 'user-item-label__square' }),
    React.createElement(Text, null, department.name)));
export default UserItemLabel;
